import { Skeleton } from '@/view/components/ui/skeleton'

export const ActiveRaffleSkeleton = () => {
  return (
    <div className="flex gap-4">
      {Array.from({ length: 3 }).map((_, index) => (
        <Skeleton
          key={index}
          className="aspect-[1179/1600] h-[451px] rounded-3xl"
        />
      ))}
    </div>
  )
}
